import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BrowserUtilsService {
    /** Verifica se o navegador é de um mobile ou não através do UserAgent */
    isMobile(): boolean {
        return navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) != null;
    }
}
